import { FC, CSSProperties } from "react"
import { ViewStyle } from "react-native"
import Lottie from "lottie-react"

interface LottieViewProps {
  animationData: any
  loop?: boolean
  autoPlay?: boolean
  style?: ViewStyle | { width?: number | string; height?: number | string }
}

/**
 * Web-specific Lottie animation wrapper
 * Uses lottie-react for web platform
 */
export const LottieView: FC<LottieViewProps> = ({
  animationData,
  loop = true,
  autoPlay = true,
  style,
}) => {
  // Convert React Native ViewStyle to CSS
  const webStyle: CSSProperties = {
    width: (style?.width as number | string) ?? undefined,
    height: (style?.height as number | string) ?? undefined,
  }

  return <Lottie animationData={animationData} loop={loop} autoplay={autoPlay} style={webStyle} />
}
